import React from "react";
import { useNavigate } from "react-router-dom";

import TopBarCenter from "@/sot/primitives/TopBarCenter.jsx";
import { useLanguage } from "@/contexts/LanguageContext.jsx";

export default function PatientPrescriptionsIndex() {
  const nav = useNavigate();
  const { t } = useLanguage();

  return (
    <div className="min-h-[100dvh] bg-[rgb(var(--clr-surface-container-low))]">
      <div className="afrimed-rail afrimed-rail--comfortable pt-4 pb-[calc(128px+env(safe-area-inset-bottom))] md:pb-12">
        <TopBarCenter
          title={t("prescriptions.index.title", "E-Prescriptions")}
          subtitle={t(
            "prescriptions.index.subtitle",
            "Review prescriptions and pharmacy fulfilment options from your appointments.",
          )}
          onBack={() => nav("/settings/patient/p/ehr")}
        />
      </div>
    </div>
  );
}
